import { BaseEntityDto } from "../BaseEntityDto";

export class BaseEventEntryTypeDto extends BaseEntityDto {
    name: string = '';
    allowedQuantity: number = 0;
}